"use client";

import { c as _c } from "react/compiler-runtime";
import { useGameLocale } from "@/lib/i18n";
import { useState, useEffect } from "react";
import { Link } from "@/i18n/navigation";
import type { Card } from "@/lib/api";
import { cachedFetch } from "@/lib/fetch-cache";
import { useBetaPrefix } from "@/lib/use-lang-prefix";
import HoverTooltip from "@/app/components/HoverTooltip";
import type { RelatedGroup as ServerGroup } from "@/lib/entity-links";
const API = process.env.NEXT_PUBLIC_API_URL ?? "http://localhost:8000";
interface RelatedCardsProps {
  currentId: string;
  keywords: string[] | null;
  tags: string[] | null;
  color: string;
  initialGroups?: ServerGroup[] | null;
}
interface RelatedGroup {
  label: string;
  cards: Card[];
}
export default function RelatedCards(t0) {
  const $ = _c(22);
  const {
    currentId,
    keywords,
    tags,
    color,
    initialGroups
  } = t0;
  const lang = useGameLocale();
  const bp = useBetaPrefix();
  let t1;
  if ($[0] !== initialGroups) {
    t1 = initialGroups ? initialGroups.map(_temp) : null;
    $[0] = initialGroups;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [groups, setGroups] = useState(t1);
  let t2;
  if ($[2] !== currentId || $[3] !== initialGroups || $[4] !== keywords || $[5] !== lang || $[6] !== tags) {
    t2 = () => {
      if (initialGroups !== undefined) {
        return;
      }
      const fetches = [];
      fetches.push(cachedFetch(`${API}/api/cards?spawns=${encodeURIComponent(currentId.toUpperCase())}&lang=${lang}`).then(cards => ({
        label: "Created or used by",
        cards: cards.filter(c => c.id !== currentId.toUpperCase()).slice(0, 12)
      })));
      if (keywords?.length) {
        for (const kw of keywords) {
          fetches.push(cachedFetch(`${API}/api/cards?keyword=${encodeURIComponent(kw)}&lang=${lang}`).then(cards_0 => ({
            label: `${kw} cards`,
            cards: cards_0.filter(c_0 => c_0.id !== currentId.toUpperCase()).slice(0, 8)
          })));
        }
      }
      if (tags?.length) {
        for (const tag of tags) {
          fetches.push(cachedFetch(`${API}/api/cards?tag=${encodeURIComponent(tag)}&lang=${lang}`).then(cards_1 => ({
            label: `${tag} cards`,
            cards: cards_1.filter(c_1 => c_1.id !== currentId.toUpperCase()).slice(0, 8)
          })));
        }
      }
      Promise.all(fetches).then(results => setGroups(results.filter(_temp2)));
    };
    $[2] = currentId;
    $[3] = initialGroups;
    $[4] = keywords;
    $[5] = lang;
    $[6] = tags;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== color || $[9] !== currentId || $[10] !== initialGroups || $[11] !== keywords || $[12] !== lang || $[13] !== tags) {
    t3 = [currentId, keywords, tags, color, lang, initialGroups];
    $[8] = color;
    $[9] = currentId;
    $[10] = initialGroups;
    $[11] = keywords;
    $[12] = lang;
    $[13] = tags;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  useEffect(t2, t3);
  if (!groups || groups.length === 0) {
    return null;
  }
  let t4;
  if ($[15] !== bp || $[16] !== groups) {
    let t5;
    if ($[18] !== bp) {
      t5 = group => <div key={group.label} className="rel-block"><div className="rl">{group.label}</div><ul className="space-y-1">{group.cards.map(card => <li key={card.id}><HoverTooltip title={card.name} content={card.description} image={card.image_url}><Link prefetch={false} href={`${bp}/cards/${card.id.toLowerCase()}`} className="text-sm text-[var(--text-secondary)] hover:text-[var(--accent-gold)] transition-colors">{card.name}</Link></HoverTooltip></li>)}</ul></div>;
      $[18] = bp;
      $[19] = t5;
    } else {
      t5 = $[19];
    }
    t4 = groups.map(t5);
    $[15] = bp;
    $[16] = groups;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[20] !== t4) {
    t5 = <>{t4}</>;
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  return t5;
}
function _temp2(g_0) {
  return g_0.cards.length > 0;
}
function _temp(g) {
  return {
    label: g.label,
    cards: g.items as unknown as Card[]
  };
}